export default {"src":"/_next/static/media/facebook.10ab8197.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};